import { cn } from '../../../utils/cn'

type ServiceToggleProps = {
  active: boolean
  label: string
  onChange: () => void
  disabled?: boolean
}

/** 40×20 pill toggle from the service card footer. */
export const ServiceToggle = ({ active, label, onChange, disabled = false }: ServiceToggleProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={active}
    disabled={disabled}
    aria-label={`${label} — ${active ? 'active' : 'inactive'}`}
    onClick={onChange}
    className={cn(
      'relative h-[20px] w-[40px] shrink-0 rounded-full transition-colors duration-200 motion-reduce:transition-none',
      active ? 'bg-black' : 'bg-dash-svc-tab-border',
    )}
  >
    <span
      className={cn(
        'absolute top-[2px] size-[16px] rounded-full bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.1)] transition-[left] duration-200 motion-reduce:transition-none',
        active ? 'left-[22px]' : 'left-[2px]',
      )}
    />
  </button>
)
